import { leaderPosts } from '@/mocks/haijiao';

const medal = ['text-amber-500', 'text-stone-400', 'text-orange-800'];

const rising = [
  { name: '冷知识研究所', desc: '稀奇古怪的小知识，越看越上头', n: '+3.2万' },
  { name: '深夜电台', desc: '睡前聊聊天，互相道一声晚安', n: '+2.8万' },
  { name: '攒钱打卡营', desc: '一起记账存钱，见证小目标达成', n: '+2.1万' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="border-b border-stone-200/80 bg-white">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-orange-600">
              <i className="ri-medal-2-fill"></i> 今日热度榜单
            </p>
            <h2 className="mt-2 text-xl font-bold tracking-tight text-stone-900 md:text-2xl">
              榜单在手，今日话题热点走势全掌握
            </h2>
          </div>
          <span className="hidden shrink-0 whitespace-nowrap rounded-full bg-orange-100 px-3 py-1 text-xs text-orange-700 sm:block">
            每小时更新
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-[1.6fr_1fr]">
          <div className="overflow-hidden rounded-2xl border border-stone-200 bg-[#fdfaf6]">
            {leaderPosts.map((l, i) => (
              <a
                key={l.rank}
                href="#feed"
                className="flex items-center gap-4 border-b border-stone-200/70 px-4 py-3 transition-colors last:border-0 hover:bg-orange-50/50 md:px-5"
              >
                <span className={`flex w-6 shrink-0 justify-center text-lg font-extrabold ${medal[i] || 'text-stone-300'}`}>
                  {i < 3 ? <i className="ri-medal-line"></i> : l.rank}
                </span>
                <span className="rounded bg-orange-100 px-1.5 py-0.5 text-[11px] text-orange-700">{l.board}</span>
                <p className="min-w-0 flex-1 truncate text-sm font-medium text-stone-800">{l.title}</p>
                <span className="flex shrink-0 items-center gap-1 text-xs font-semibold text-orange-600">
                  <i className="ri-fire-line"></i> {l.heat}
                </span>
              </a>
            ))}
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-2xl border border-stone-200 bg-[#fdfaf6] p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-stone-900">
                <i className="ri-rocket-2-line text-orange-600"></i> 本周新晋圈子
              </h3>
              <div className="mt-3 space-y-3">
                {rising.map((r) => (
                  <div key={r.name} className="flex items-center gap-3 rounded-xl bg-white p-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-orange-100 text-orange-700">
                      <i className="ri-compass-3-line text-lg"></i>
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold text-stone-800">{r.name}</p>
                      <p className="truncate text-xs text-stone-400">{r.desc}</p>
                    </div>
                    <span className="shrink-0 whitespace-nowrap rounded-full bg-orange-100 px-2 py-0.5 text-[11px] font-semibold text-orange-700">
                      {r.n}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-1 rounded-2xl border border-dashed border-orange-300 bg-orange-50 p-5">
              <p className="text-sm font-bold text-stone-900">想当话题热榜第一？</p>
              <p className="mt-1 text-xs leading-relaxed text-stone-500">
                去广场发起你的帖子，参与热门板块讨论，话题热度持续攀升就能冲上榜单。
              </p>
              <a
                href="#download"
                className="mt-3 inline-block whitespace-nowrap rounded-full bg-orange-600 px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-orange-700"
              >
                去发条帖子
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}